import api from './api';

export enum UserType {
  DOCTOR = 'doctor',
  CASE_MANAGER = 'case_manager',
  NURSE_PRESCRIBER = 'nurse_prescriber',
}

export const USER_TYPE_LABELS: Record<UserType, string> = {
  [UserType.DOCTOR]: 'Doctor',
  [UserType.CASE_MANAGER]: 'Case Manager',
  [UserType.NURSE_PRESCRIBER]: 'Nurse Prescriber',
};

export enum MeetingTypeCategory {
  CASE_MANAGER_INTAKE = 'case_manager_intake',
  PSY_INTAKE = 'psy_intake',
  CASE_MANAGER_FOLLOWUP = 'case_manager_followup',
  PSY_FOLLOWUP = 'psy_followup',
  TITRATION_INTAKE = 'titration_intake',
  TITRATION_FOLLOWUP = 'titration_followup',
}

export const MEETING_TYPE_CATEGORY_LABELS: Record<MeetingTypeCategory, string> = {
  [MeetingTypeCategory.CASE_MANAGER_INTAKE]: 'Case Manager Intake',
  [MeetingTypeCategory.PSY_INTAKE]: 'Psychiatrist Intake',
  [MeetingTypeCategory.CASE_MANAGER_FOLLOWUP]: 'Case Manager Follow-up',
  [MeetingTypeCategory.PSY_FOLLOWUP]: 'Psychiatrist Follow-up',
  [MeetingTypeCategory.TITRATION_INTAKE]: 'Titration Intake',
  [MeetingTypeCategory.TITRATION_FOLLOWUP]: 'Titration Follow-up',
};

export interface SummaryTypeInfo {
  id: number;
  name: string;
  summary_sections?: any[] | null;
  pdf_layout?: any[] | null;
}

export interface MeetingType {
  id: number;
  name: string;
  user_type: UserType;
  type: MeetingTypeCategory | null;
  yoman_id: string;
  yoman_interval: number;
  tenant_id: number;
  summary_type_id?: number | null;
  summary_type?: SummaryTypeInfo | null;
  questionnaire_type_ids?: number[] | null;
  only_once: boolean;
  created_at: string;
  updated_at: string;
}

export interface MeetingTypeCreate {
  name: string;
  user_type: UserType;
  type?: MeetingTypeCategory | null;
  yoman_id: string;
  yoman_interval: number;
  tenant_id?: number;
  summary_type_id?: number | null;
  questionnaire_type_ids?: number[] | null;
  only_once?: boolean;
}

export interface MeetingTypeUpdate {
  name?: string;
  user_type?: UserType;
  type?: MeetingTypeCategory | null;
  yoman_id?: string;
  yoman_interval?: number;
  summary_type_id?: number | null;
  questionnaire_type_ids?: number[] | null;
  only_once?: boolean;
}

// Re-export for consumers that imported SummarySectionConfig from here
export type { SummarySectionConfig } from './summaryTypeService';

export const meetingTypeService = {
  async getMeetingTypes(tenantId?: number): Promise<MeetingType[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/meeting-types/${params}`);
    return response.data;
  },

  async getMeetingType(meetingTypeId: number): Promise<MeetingType> {
    const response = await api.get(`/meeting-types/${meetingTypeId}`);
    return response.data;
  },

  async createMeetingType(meetingTypeData: MeetingTypeCreate): Promise<MeetingType> {
    const response = await api.post('/meeting-types/', meetingTypeData);
    return response.data;
  },

  async updateMeetingType(meetingTypeId: number, meetingTypeData: MeetingTypeUpdate): Promise<MeetingType> {
    const response = await api.put(`/meeting-types/${meetingTypeId}`, meetingTypeData);
    return response.data;
  },

  async deleteMeetingType(meetingTypeId: number): Promise<void> {
    await api.delete(`/meeting-types/${meetingTypeId}`);
  },
};
